if (!customElements.get('ib-product-options')) {
  customElements.define('ib-product-options', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.variants = JSON.parse(this.querySelector('[data-ib-variants]').textContent);
      this.colourAliases = JSON.parse(this.querySelector('[data-ib-colour-aliases]')?.textContent || '{}');
      this.prices = JSON.parse(this.querySelector('[data-ib-prices]')?.textContent || '{}');
      this.section = this.closest('.shopify-section');
      this.colorIndex = Number(this.dataset.colorIndex);
      this.sizeIndex = Number(this.dataset.sizeIndex);
      this.form = document.getElementById(this.dataset.formId);
      this.scope = this.closest('.product-details') || this.parentElement;
      const initial = this.variants.find(v => String(v.id) === this.dataset.initialVariant) || this.variants[0];
      this.initial = initial;
      this.readUrl();
      this.querySelectorAll('[role="radiogroup"]').forEach(group => {
        [...group.children].sort((a,b) => Number(a.style.order || 0) - Number(b.style.order || 0)).forEach(b => group.append(b));
      });
      this.addEventListener('click', (event) => {
        const color = event.target.closest('[data-color]');
        const size = event.target.closest('[data-size]');
        if (!color && !size) return;
        this.message = '';
        if (color) {
          this.color = color.dataset.color;
          if (this.size && !this.match(this.size)?.available) {
            this.size = null;
            this.message = this.dataset.unavailableSize;
          }
        }
        if (size) {
          if (size.getAttribute('aria-disabled') === 'true') this.message = this.dataset.unavailableSize;
          else this.size = size.dataset.size;
        }
        this.update(true, Boolean(color));
      }, { signal });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) return;
        const group = event.target.closest('[role="radiogroup"]');
        if (!group) return;
        const buttons = [...group.querySelectorAll('button')].filter(b => b.getAttribute('aria-disabled') !== 'true');
        if (!buttons.length) return;
        const step = ['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1;
        const next = buttons[(buttons.indexOf(event.target) + step + buttons.length) % buttons.length];
        event.preventDefault(); next.focus(); next.click();
      }, { signal });
      this.scope.addEventListener('click', event => {
        if (!event.target.closest('[name="add"], add-to-cart-component button, [data-ib-buy-now]') || this.size) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.chooseSize();
      }, { signal, capture:true });
      this.form?.addEventListener('submit', event => {
        if (this.size && this.variant?.available) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.chooseSize();
      }, { signal, capture:true });
      window.addEventListener('popstate', () => {
        const previousColor = this.color;
        this.readUrl();
        this.update(false, this.color !== previousColor);
      }, { signal });
      this.update(false,true);
    }
    disconnectedCallback() { this.abort?.abort(); this.bound = false; }
    colourKey(value) { const key = String(value || '').trim().toLowerCase(); return this.colourAliases[key] || key; }
    readUrl() {
      const params = new URL(location.href).searchParams;
      const requested = this.variants.find(v => String(v.id) === params.get('variant'));
      const colorOnly = this.variants.find(v => this.colorIndex >= 0 && this.colourKey(v.options[this.colorIndex]) === this.colourKey(params.get('ib_color')));
      const initial = requested || colorOnly || this.initial;
      this.color = this.colorIndex >= 0 ? initial.options[this.colorIndex] : null;
      this.size = requested && this.sizeIndex >= 0 ? requested.options[this.sizeIndex] : null;
      this.message = '';
    }
    match(size) {
      return this.variants.find(v => (this.colorIndex < 0 || v.options[this.colorIndex] === this.color) && (this.sizeIndex < 0 || !size || v.options[this.sizeIndex] === size));
    }
    chooseSize() {
      this.message = this.dataset.chooseSize;
      this.update(false, false);
      const button = this.querySelector('[data-size]:not([aria-disabled="true"])') || this.querySelector('[data-size]');
      button?.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      button?.focus({ preventScroll: true });
    }
    update(changeUrl, changeMedia) {
      this.variant = this.match(this.size);
      const v = this.variant;
      this.ready = Boolean(this.size && v?.available);
      this.querySelectorAll('[data-color]').forEach(b => { const selected = b.dataset.color === this.color; b.setAttribute('aria-checked', String(selected)); b.tabIndex = selected ? 0 : -1; });
      let firstAvailable = true;
      this.querySelectorAll('[data-size]').forEach(b => {
        const available = Boolean(this.match(b.dataset.size)?.available);
        const selected = b.dataset.size === this.size;
        b.setAttribute('aria-disabled', String(!available)); b.setAttribute('aria-checked', String(selected));
        b.tabIndex = selected || (!this.size && available && firstAvailable) ? 0 : -1;
        if (available) firstAvailable = false;
      });
      const label = this.querySelector('[data-ib-selected-color]');
      if (label) {
        const selectedColor = [...this.querySelectorAll('[data-color]')].find(button => button.dataset.color === this.color);
        label.textContent = selectedColor?.dataset.colorLabel || this.color;
      }
      const confirmedColor = this.querySelector('[data-ib-confirm-color]');
      if (confirmedColor) {
        const selectedColor = [...this.querySelectorAll('[data-color]')].find(button => button.dataset.color === this.color);
        confirmedColor.value = selectedColor?.dataset.colorLabel || this.color || '';
      }
      const input = this.form?.querySelector('[name="id"]');
      if (input) { input.value = this.ready ? v.id : ''; input.dispatchEvent(new Event('change', {bubbles:true})); }
      this.scope.querySelectorAll('add-to-cart-component button, [data-ib-buy-now]').forEach(b => { b.disabled = !this.size || !v?.available; });
      const error = this.querySelector('[data-ib-options-error]');
      error.textContent = this.message || this.dataset.chooseSize; error.hidden = !this.message;
      const price = this.prices[v?.id];
      if (price) this.section?.querySelectorAll('product-price').forEach(el => {
        if (el.dataset.productId && el.dataset.productId !== this.dataset.productId) return;
        el.querySelectorAll('.price').forEach(node => { node.innerHTML = price.price; });
        el.querySelectorAll('.compare-at-price').forEach(node => { node.innerHTML = price.compare; });
        const sale = v.compare_at_price > v.price;
        el.querySelector('.price__regular')?.classList.toggle('price__hidden', sale);
        el.querySelector('.price__sale')?.classList.toggle('price__hidden', !sale);
      });
      if (changeUrl) {
        const url = new URL(location.href);
        url.searchParams.delete('variant'); url.searchParams.delete('ib_color');
        if (this.ready) url.searchParams.set('variant', v.id);
        else if (this.color) url.searchParams.set('ib_color', this.colourKey(this.color));
        if (url.href !== location.href) history.pushState({...history.state}, '', url);
      }
      const mediaVariant = v?.featured_media ? v : this.variants.find(candidate => (this.colorIndex < 0 || candidate.options[this.colorIndex] === this.color) && candidate.featured_media);
      const gallery = this.closest('.product-information')?.querySelector('ib-product-gallery') || document.querySelector('ib-product-gallery');
      const requestedMedia = new URL(location.href).searchParams;
      if (changeMedia && (changeUrl || requestedMedia.has('variant') || requestedMedia.has('ib_color'))) {
        const mediaId = mediaVariant?.featured_media?.id;
        customElements.whenDefined('ib-product-gallery').then(() => {
          gallery?.selectColor(this.colourKey(this.color), mediaId);
        });
      }
      const mappedMedia = gallery?.querySelector('[data-ib-gallery-groups]');
      const groups = mappedMedia ? JSON.parse(mappedMedia.textContent) : [];
      const group = groups.find?.(entry => entry.color === this.colourKey(this.color));
      const firstMediaId = group?.images?.[0];
      const mappedImage = firstMediaId && gallery?.querySelector(`[data-media-id="${firstMediaId}"] img`);
      const media = mappedImage?.currentSrc || mappedImage?.src || mediaVariant?.featured_image?.src || gallery?.querySelector('img')?.src || '';
      if (this.scope) this.scope.querySelector('add-to-cart-component')?.setAttribute('data-product-variant-media',media);
      document.dispatchEvent(new CustomEvent('variant:change',{detail:{productId:this.dataset.productId,variant:v,color:confirmedColor?.value || label?.textContent || '',size:this.size,ready:this.ready,media}}));
    }
  });
}
